import {
  IFintechFilters,
  IFintechWeakSignalsFilters,
  IinitialStateServerFintech,
} from "../pages/Fintech/FintechDashboard.type";

const useFinTechFilteredData = (
  dataServer: IinitialStateServerFintech,
  filters: IFintechFilters,
  filterWeakSignals: IFintechWeakSignalsFilters
) => {
  if (!filterWeakSignals.weak_signal.value) {
    const filtered = dataServer?.trends.filter((trend) => {
      let isFiltered = true;
      Object.keys(filters).forEach((key) => {
        if (
          filters[key as keyof typeof filters].value !== 0 &&
          filters[key as keyof typeof filters].value !== null
          // filters[key as keyof typeof filters].value !== false
        ) {
          if (
            filters[key as keyof typeof filters].value !==
            trend[key as keyof typeof filters]
          ) {
            isFiltered = false;
          }
        }
      });

      if (isFiltered) return trend;
    });
    const newObject = {
      ...dataServer,
      trends: filtered,
    };

    return newObject;
  } else {
    const newObject = {...dataServer};

    return newObject;
  }
};

export default useFinTechFilteredData;
